import { ENV } from "./env";

export const MONTHLY_MIN_PRIME_PRICE = ENV.PRICES.MONTHLY_MIN_PRIME_PRICE;

export const HOUSING_INSURANCE_PRICE_TIER_1 = ENV.PRICES.HOUSING_INSURANCE_PRICE_TIER_1;
export const HOUSING_INSURANCE_PRICE_TIER_2 = ENV.PRICES.HOUSING_INSURANCE_PRICE_TIER_2;

export const ASSETS_INSURANCE_PRICE_TIER_1 = ENV.PRICES.ASSETS_INSURANCE_PRICE_TIER_1;

export const SECURITY_SYSTEM_DISCOUNT_PERCENTAGE = 10;
